// extracted by mini-css-extract-plugin
export default {"btn":"AntdButtonCustom_btn__sZpLn"};